import { Fragment } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import {
  InputOptionContainer, InputOption, ResultIcon, ResultInfo, ResultInfoContainer,
} from './styles';
import { LoaderBox } from '../entity-loader/loader-box';

const TYPES = {
  TAG: 'tag',
  ITEM: 'item',
  QUERY: 'query',
  PROJECT: 'project',
};

const ICON_CLASSNAME = {
  [TYPES.TAG]: 'icon-tag',
  [TYPES.ITEM]: 'icon-magnifier',
  [TYPES.QUERY]: 'icon-magnifier',
  [TYPES.PROJECT]: 'icon-projects',
};

const getOption = (onSelect) => ({ id, name, type }) => (
  <Fragment key={id}>
    <InputOption onClick={() => onSelect(id)}>
      <ResultIcon className={ICON_CLASSNAME[type]} />
      <span>{name}</span>
    </InputOption>
  </Fragment>
);

const Options = ({
  options = [],
  loading,
  onSelect,
}) => (
  <>
    <InputOptionContainer>
      <SwitchTransition>
        <CSSTransition
          key={loading ? 'loading' : 'item'}
          mountOnEnter
          unmountOnExit
          in={loading}
          appear={loading}
          timeout={300}
          classNames="fade"
        >
          {/* eslint-disable-next-line no-nested-ternary */}
          {loading ? (<LoaderBox />) : (
            options.length
              ? (
                <div>
                  {options.slice(0, 15).map(getOption(onSelect))}
                  {
                    options.length - 15 > 0 ? (
                      <ResultInfoContainer>
                        <ResultInfo>
                          ...and
                          {options.length - 15}
                          {' '}
                          more results
                        </ResultInfo>
                      </ResultInfoContainer>
                    ) : null
                  }
                </div>
              )
              : (<ResultInfo>No options found</ResultInfo>)
          )}
        </CSSTransition>
      </SwitchTransition>
    </InputOptionContainer>
  </>
);

export default Options;
